import Image from 'next/image'
import Link, { LinkProps } from 'next/link'

import logo from '../../public/images/dwelinn.png'
import logoSmall from '../../public/images/favicon.png'
type LogoProps = LinkProps & {
  type?: 'small' | 'large'
}

export function Logo({ type = 'large', ...rest }: LogoProps) {
  return type === 'large' ? (
    <Link {...rest}>
      <Image
        src={logo}
        alt="Dwelinn"
        width={71}
        height={20}
        priority
        sizes="71px"
      />
    </Link>
  ) : (
    <Link {...rest}>
      <Image
        src={logoSmall}
        width={35}
        height={35}
        alt="Dwelinn"
        priority
        className="aspect-square size-[35px]"
      />
    </Link>
  )
}
